import React, { Component } from 'react';
import styles from './styles.scss';
import logo from 'assets/images/logo.png';
import bg from 'assets/images/signup-background.jpg';

export default class Maintenance extends Component {
  render() {
    return (
      <div
        className={styles.wrapper}
        style={{ backgroundImage: `url('${bg}')` }}>
        <div className={styles.innerWrapper}>
          <div>
            <img src={logo} alt="logo" />
          </div>
          <div className={styles.text}>
            Your app is currently getting an update!<br />
            Please check back in a few minutes.
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/maintenance/index.js